import { render, staticRenderFns } from "./ItemChipLinkRustlabs.vue?vue&type=template&id=0d6d70df&scoped=true&"
import script from "./ItemChipLinkRustlabs.vue?vue&type=script&lang=ts&"
export * from "./ItemChipLinkRustlabs.vue?vue&type=script&lang=ts&"
import style0 from "./ItemChipLinkRustlabs.vue?vue&type=style&index=0&id=0d6d70df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6d70df",
  null
  
)

export default component.exports